import React from "react";
import tick from "../../pages/images/green-tick.svg";
import "./style.css";
import { Message } from "../../lib/getMessage";

const ResponseModal = (props) => (
  <div className="demo-form tc">
    <img src={tick} alt="" width="75" height="75" loading="lazy" />
    <h2>
      <Message dictKey="thank.you" />
    </h2>
    <p>
      <Message dictKey="will.get.in.touch" />
    </p>
    <button className="grey-button" onClick={props.onClose}>
      <Message dictKey="ok" />
    </button>
  </div>
);

export default ResponseModal;
